import styled from '@emotion/styled'
import { Icon } from 'components/icon'
import { Text } from 'components/Typography'
import { BREAKPOINTS, hiddenScrollbarCss, pxToRem } from 'utils/styled'

export const SSection = styled.section`
  display: grid;
  grid-template-areas: 'image text';
  grid-template-columns: 1fr 1fr;
  @media ${BREAKPOINTS.XL.max} {
    grid-template-columns: 2fr 3fr;
  }
  @media ${BREAKPOINTS.LG.max} {
    grid-template-columns: 1fr 1fr;
  }
  @media ${BREAKPOINTS.MD.max} {
    grid-template-areas: 'text';
    grid-template-columns: 1fr;
  }
`

export const SImageArea = styled.div`
  grid-area: image;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;

  align-self: center;
  overflow: hidden;
  & > * {
    margin-right: max(min(calc(100vw - 2000px), 0px), -350px);

    @media ${BREAKPOINTS.XL.max} {
      margin-left: -150px;
    }
  }

  @media ${BREAKPOINTS.MD.max} {
    display: none;
  }
`

export const SDescriptionText = styled(Text)`
  color: var(--c-gray400);
`

export const STextArea = styled.div`
  grid-area: text;
  background-color: var(--c-gray100);
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
  padding-right: 3rem;
  padding-left: 4.75rem;
  @media ${BREAKPOINTS.MD.max} {
    padding: 3rem 1rem;
    max-width: 100vw;
  }
`

export const STextAreaContent = styled.div`
  max-width: ${pxToRem(688)}rem;
`

export const SCardList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1rem;

  @media ${BREAKPOINTS.XL.max} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${BREAKPOINTS.MD.max} {
    grid-template-columns: repeat(4, ${pxToRem(200)}rem);
    overflow-x: scroll;
    overflow-y: hidden;

    ${hiddenScrollbarCss}
  }
`

export const SCard = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border: 1px solid #ffffff19;
  padding: 1rem;
`

export const SCardIcon = styled(Icon)`
  margin-bottom: 1.5rem;
`
